// Standalone full-page renderer for /privacy /terms /copyright.
// Used by App.jsx path-based routing so Google OAuth consent screen has real URLs.

import { PRIVACY, TERMS, COPYRIGHT } from '../data/legal.js';

const DOCS = { privacy: PRIVACY, terms: TERMS, copyright: COPYRIGHT };

const STYLE_ID = 'legal-page-styles';
if (typeof document !== 'undefined' && !document.getElementById(STYLE_ID)) {
  const el = document.createElement('style');
  el.id = STYLE_ID;
  el.textContent = `
    :root{
      --gold:#f5dc64;--gold2:#d4a820;
      --cosmos:#0a0805;--cosmos2:#120f08;--cosmos3:#1c1710;
      --text:#dcc888;
    }
    .lp-root{min-height:100vh;background:var(--cosmos);color:var(--text);
      font-family:'IM Fell English',Georgia,serif;padding:40px 20px;
      display:flex;justify-content:center;overflow-x:hidden}
    .lp-wrap{max-width:720px;width:100%}
    .lp-nav{margin-bottom:32px;display:flex;justify-content:space-between;align-items:center;
      font-family:'Cinzel',serif;font-size:10px;letter-spacing:4px}
    .lp-nav a{color:rgba(245,220,100,.55);text-decoration:none;
      border:1px solid rgba(245,220,100,.18);padding:8px 18px;border-radius:2px;
      transition:all .3s;text-transform:uppercase}
    .lp-nav a:hover{background:rgba(245,220,100,.07);color:var(--gold);
      border-color:rgba(245,220,100,.35)}
    .lp-brand{color:var(--gold);font-family:'Cinzel Decorative',serif;
      font-size:14px;letter-spacing:3px}
    .lp-card{background:var(--cosmos2);border:1px solid rgba(245,220,100,.18);
      padding:clamp(28px,5vw,56px);border-radius:2px;
      box-shadow:0 20px 60px rgba(0,0,0,.5),inset 0 1px 0 rgba(245,220,100,.05)}
    .lp-card h1{font-family:'Cinzel Decorative',serif;font-size:clamp(22px,3.5vw,30px);
      color:var(--gold);margin:0 0 8px;letter-spacing:2px}
    .lp-date{font-family:'Cinzel',serif;font-size:9px;letter-spacing:4px;
      color:rgba(245,220,100,.3);margin-bottom:36px;text-transform:uppercase}
    .lp-card h2{font-family:'Cinzel',serif;font-size:11px;letter-spacing:4px;
      color:rgba(245,220,100,.65);text-transform:uppercase;margin:32px 0 12px}
    .lp-card p{font-family:'IM Fell English',Georgia,serif;font-style:italic;
      font-size:14.5px;line-height:2;color:rgba(220,203,136,.72);margin:0 0 12px}
    .lp-footer{margin-top:40px;padding-top:24px;border-top:1px solid rgba(245,220,100,.08);
      text-align:center;font-family:'Cinzel',serif;font-size:9px;letter-spacing:3px;
      color:rgba(245,220,100,.35);text-transform:uppercase}
    .lp-footer a{color:rgba(245,220,100,.55);text-decoration:none;margin:0 8px}
    .lp-footer a:hover{color:var(--gold)}
  `;
  document.head.appendChild(el);
}

export default function LegalPage({ kind }) {
  const doc = DOCS[kind];
  if (!doc) return null;

  return (
    <div className="lp-root">
      <div className="lp-wrap">
        <div className="lp-nav">
          <a href="/">← Home</a>
          <div className="lp-brand">RASAVISIO</div>
        </div>

        <div className="lp-card">
          <h1>{doc.title}</h1>
          <div className="lp-date">{doc.date}</div>
          {doc.sections.map((s, i) => (
            <div key={i}>
              <h2>{s.h}</h2>
              <p>{s.b}</p>
            </div>
          ))}
        </div>

        <div className="lp-footer">
          <a href="/privacy">Privacy</a>·
          <a href="/terms">Terms</a>·
          <a href="/copyright">Copyright</a>
          <div style={{ marginTop: 12 }}>© 2024–2026 RasaVisio</div>
        </div>
      </div>
    </div>
  );
}
